export default "__VITE_ASSET__BGJUvTwD__"